import React from "react";
import Classes from "./style.module.css";
import UserImg from "../../../../assets/images/lig/ProfileImg.png";
import FirstPlaceImg from "../../../../assets/images/lig/firstPlaceProfileImg.png";

const LigPodium = ({ data }) => {
  function formatData(data) {
    const dataStr = data.toString();
    const start = dataStr.substring(0, 3);
    const end = dataStr.substring(dataStr.length - 2);
    const formattedData = `${end}**${start}`;
    return formattedData;
  }
  return (
    <div className={Classes.podiumContainer}>
      <div className={Classes.Content}>
        <h5 className="text-center">جدول پیشتازان</h5>
        <div className={Classes.podiumContent}>
          <div className={Classes.podiumElement}>
            <img src={UserImg} alt="user-img" />
            <p>رتبه سوم</p>
            <p>{data[2] ? data[2].name : "نام"}</p>
            <p>{data[2] ? formatData(data[2].codeMeli) : "کدملی"}</p>
            <p>{data[2] ? data[2].score : "0"} امتیاز</p>
          </div>
          <div className={Classes.firstPlaceContainer}>
            <img src={FirstPlaceImg} alt="user-img" />
            <p>رتبه اول</p>
            <p>{data[0] ? data[0].name : "نام"}</p>
            <p>{data[0] ? formatData(data[0].codeMeli) : "کدملی"}</p>
            <p>{data[0] ? data[0].score : "0"} امتیاز</p>
          </div>
          <div className={Classes.podiumElement}>
            <img src={UserImg} alt="user-img" />
            <p>رتبه دوم</p>
            <p>{data[1] ? data[1].name : "نام"}</p>
            <p>{data[1] ? formatData(data[1].codeMeli) : "کدملی"}</p>
            <p>{data[1] ? data[1].score : "0"} امتیاز</p>
          </div>
        </div>
      </div>
      <div className={Classes.curveBg}></div>
    </div>
  );
};

export default LigPodium;
